import { useDownload } from '../contexts/Download';
import NavigationMenu from './Header/NavigationMenu';
import SearchForm from './Header/SearchForm';

export function HeaderMenu({
  text_description,
  description,
  submitHandler,
  onChangehandler,
  placeholder,
}) {
  const { clickDownload, setClickDownload } = useDownload();
  // useEffect(() => {
  //   setClickDownload(!clickDownload);
  // }, []);
  return (
    <div className="header-background">
      <div className="description">
        <h2 className="text-description">{text_description}</h2>
        <p className="text-description p-description">{description}</p>
      </div>
      <SearchForm
        submitHandler={submitHandler}
        onChangehandler={onChangehandler}
        placeholder={placeholder}
      />
      <p className="text-description text-center">
        Escolha abaixo as opções que deseja para fazer o download de forma
        online e grátis:
      </p>
      <nav className="nav-section">
        <div className="navigation flex container justify-content-center text-center m-auto col-md-8 col-12">
          <NavigationMenu />
        </div>
      </nav>

      {clickDownload && (
        <>
          <div className="text-center">
            <h3 className="text-description">
              Conheça a Ferramenta de Engajamento que já ajudou mais de{' '}
              <strong>46 mil clientes</strong> em todo Brasil!
            </h3>
            <p className="text-description p-description">
              Assista antes que este vídeo saia do ar!
            </p>
            <iframe
              id="panda-d57ddd37-fa73-4880-8894-781b2ec6fd3e"
              src="https://player-vz-d55d88c5-3db.tv.pandavideo.com.br/embed/?v=d57ddd37-fa73-4880-8894-781b2ec6fd3e"
              style={{ border: 'none' }}
              allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture"
              allowfullscreen
              className="iframe-video"
              fetchpriority="high"
            />
          </div>
        </>
      )}
    </div>
  );
}
